import { OddsTypes } from 'constants/app';
import { OddsType } from 'types';

export const oddsTypeSettingsName = 'asianViewOddsType';

export const oddsTypePreferencesOptions: {
  id: string;
  value: Extract<OddsType, 'decimal' | 'american'>;
  label: string;
}[] = [
  {
    id: OddsTypes.DEC,
    value: OddsTypes.DEC,
    label: 'account.settings.oddsType.decimal'
  },
  {
    id: OddsTypes.US,
    value: OddsTypes.US,
    label: 'account.settings.oddsType.american'
  }
];
